"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockDomainModal = BlockDomainModal;
exports.UnblockDomailModal = UnblockDomailModal;
exports.UnblockSenderModal = UnblockSenderModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["email"],
  _excluded2 = ["domain", "relatedContacts"],
  _excluded3 = ["email", "domain"];
function BlockTitle(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold mb-2"
  }, t('block.domain.title'));
}
function UnblockDomainTitle(props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold mb-2"
  }, t('unblock.domain.title'));
}
function UnblockSenderTitle(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold mb-2"
  }, t('unblock.sender.title'));
}
function UnblockDomianWithoutSender(props) {
  var domain = props.domain;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, t('unblock.domain.confim.title', {
    domain: domain
  }), ' ', t('unblock.domain.prompt', {
    domain: domain
  }));
}
function UnblockDomianWithSender(props) {
  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation5.t;
  var relatedContacts = props.relatedContacts,
    domain = props.domain;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, t('unblock.domain.confim.title', {
    domain: domain
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "unblock.domain.with.sender",
    count: relatedContacts
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-red"
  }, "Note:"), " ", {
    relatedContacts: relatedContacts
  }, " other senders with this domain are still in your blocked list")));
}
function UnblockSenderWithDomain(props) {
  var email = props.email,
    domain = props.domain;
  var _useTranslation6 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation6.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, t('unblock.sender.confim.with.domain', {
    email: email
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "unblock.sender.with.domain",
    values: {
      domain: domain
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-red"
  }))));
}
function getDomianByEmail(email) {
  if (email) {
    var _email$split = email.split('@'),
      _email$split2 = (0, _slicedToArray2["default"])(_email$split, 2),
      domain = _email$split2[1];
    return "\"@".concat(domain, "\"");
  }
  return '';
}
function BlockBody(props) {
  var _useTranslation7 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation7.t;
  var email = props.email;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, t('block.domain.prompt', {
    domain: getDomianByEmail(email)
  })), /*#__PURE__*/_react["default"].createElement("div", null, t('block.domain.confim')));
}
var DomainDialog = function DomainDialog(_ref) {
  var isOpen = _ref.isOpen,
    email = _ref.email,
    domain = _ref.domain,
    relatedContacts = _ref.relatedContacts,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm,
    children = _ref.children,
    _ref$isBlockFooterTex = _ref.isBlockFooterText,
    isBlockFooterText = _ref$isBlockFooterTex === void 0 ? true : _ref$isBlockFooterTex;
  var _useTranslation8 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation8.t;
  function handleOnCancel() {
    onClose();
  }
  function handleOnBlockAll(email) {
    onConfirm && onConfirm(email);
  }
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    onClose: onClose,
    open: isOpen
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col flex-1 w-full p-8"
  }, children, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: handleOnCancel,
    className: "w-32 !py-3 mr-4"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "warning",
    className: "w-32 !py-3",
    onClick: function onClick() {
      return handleOnBlockAll(email);
    }
  }, isBlockFooterText ? t('button.block.all') : t('button.unblock')))));
};
function BlockDomainModal(props) {
  var email = props.email,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(DomainDialog, rest, /*#__PURE__*/_react["default"].createElement(BlockTitle, null), /*#__PURE__*/_react["default"].createElement(BlockBody, {
    email: email
  }));
}
function UnblockDomailModal(props) {
  var domain = props.domain,
    relatedContacts = props.relatedContacts,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(DomainDialog, (0, _extends2["default"])({
    isBlockFooterText: false
  }, rest), /*#__PURE__*/_react["default"].createElement(UnblockDomainTitle, null), relatedContacts ? /*#__PURE__*/_react["default"].createElement(UnblockDomianWithSender, {
    domain: domain,
    relatedContacts: relatedContacts
  }) : /*#__PURE__*/_react["default"].createElement(UnblockDomianWithoutSender, {
    domain: domain
  }));
}
function UnblockSenderModal(props) {
  var email = props.email,
    domain = props.domain,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(DomainDialog, (0, _extends2["default"])({
    isBlockFooterText: false
  }, rest), /*#__PURE__*/_react["default"].createElement(UnblockSenderTitle, null), /*#__PURE__*/_react["default"].createElement(UnblockSenderWithDomain, {
    email: email,
    domain: domain
  }));
}
//# sourceMappingURL=index.js.map